import { useState } from 'react'
import { useSelector } from 'react-redux'
import Sidebar  from './components/sidebar'
import Topbar   from './components/topbar'
import navigation from '../navigation/vertical'
import './VerticalLayout.scss'

const VerticalLayout = ({ children }) => {
  const [menuCollapsed, setMenuCollapsed] = useState(false)
  const skin = useSelector(s => s.layout?.skin || 'light')

  return (
    <div className={`vertical-layout ${menuCollapsed ? 'menu-collapsed' : 'menu-expanded'}`}>
      <Sidebar
        menuData={navigation}
        menuCollapsed={menuCollapsed}
        setMenuCollapsed={setMenuCollapsed}
        skin={skin}
      />
      <div className="app-content-wrapper">
        <Topbar />
        <main className="app-content">
          {children}
        </main>
      </div>
    </div>
  )
}

export default VerticalLayout